import React from "react";
import { Field } from "formik";
import { SimpleSingleSelect } from "./SimpleSingleSelect";
import { InputField } from "@coverme/forms";
import { get } from "lodash-es";

export const InterviewPersonDocumentation = ({
    fullName,
    documentTypeName,
    documentNumberName,
    issuingStateName,
    getValidationState,
    getErrors,
    setFieldValue,
    setFieldTouched,
    documentTypes,
    states,
    isRequired,
    values,
    fieldBaseName,
    documentTypePath = "documentType",
    documentName = null,
    isDisabled = false,
}) => {
    const idsThatRequireIssuingState = ["Birth Certificate", "Driver's License", "State ID"];
    if (isRequired == null) {
        isRequired = () => false;
    }
    if (fieldBaseName !== "") {
        documentTypePath = `${fieldBaseName}.documentType`;
    }
    return (
        <>
            <div className="form-control xxl-input">
                <Field
                    name={documentTypeName}
                    render={({ field }) => (
                        <SimpleSingleSelect
                            {...field}
                            title={`Select ID Type`}
                            id={field.name}
                            value={field.value}
                            required={isRequired(field)}
                            errorMessage={getErrors(field)}
                            validState={getValidationState(field)}
                            setFieldTouched={setFieldTouched}
                            setFieldValue={setFieldValue}
                            options={documentTypes}
                            disabled={isDisabled}
                        />
                    )}
                />
            </div>
            {get(values, documentTypePath) === "Other" && (
                <div className="form-control xl-input">
                    <Field
                        name={!documentName ? `${documentTypeName}Other` : documentName}
                        render={({ field }) => (
                            <>
                                <InputField
                                    {...field}
                                    title="Type"
                                    id={field.name}
                                    validState={getValidationState(field)}
                                    errorMessage={getErrors(field)}
                                    required={isRequired(field)}
                                    placeholder="Type"
                                    value={field.value}
                                    disabled={isDisabled}
                                />
                            </>
                        )}
                    />
                </div>
            )}
            <div className="form-control s-140-input has-tooltip">
                <Field
                    name={documentNumberName}
                    render={({ field }) => (
                        <>
                            <InputField
                                {...field}
                                title="ID Number"
                                id={field.name}
                                validState={getValidationState(field)}
                                errorMessage={getErrors(field)}
                                required={isRequired(field)}
                                placeholder="12XX331"
                                value={field.value}
                                disabled={isDisabled}
                            />
                        </>
                    )}
                />
            </div>
            {/*{get(values, documentTypePath) === "Driver's License" && (*/}
            {idsThatRequireIssuingState.findIndex(x => x === get(values, documentTypePath)) >= 0 && (
                <div className="form-control s-input">
                    <Field
                        name={issuingStateName}
                        render={({ field }) => (
                            <SimpleSingleSelect
                                {...field}
                                id={field.name}
                                title={"Issuing State"}
                                setFieldTouched={setFieldTouched}
                                setFieldValue={setFieldValue}
                                required={isRequired(field)}
                                errorMessage={getErrors(field)}
                                validState={getValidationState(field)}
                                options={states}
                                value={field.value}
                                disabled={isDisabled}
                            />
                        )}
                    />
                </div>
            )}
        </>
    );
};
